import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { QuizLayoutComponent } from './quiz-layout.component';

@NgModule({
  declarations: [QuizLayoutComponent],
  imports: [CommonModule, TranslateModule],
  exports: [QuizLayoutComponent],
})
export class QuizLayoutModule {}
